import { Injectable } from '@angular/core';
import { WindowRef } from '@spartacus/core';

import { CustomerData } from '../../models/customer.model';

const KN_BR_CUSTOMER_CONTEXT_STORAGE_KEY = 'kn-br-customer-context';

@Injectable({
  providedIn: 'root',
})
export class KnBrCustomerContextAdapter {
  constructor(private winRef: WindowRef) {}

  get() {
    if (this.winRef.localStorage) {
      const context = this.winRef.localStorage.getItem(KN_BR_CUSTOMER_CONTEXT_STORAGE_KEY);
      if (context) {
        try {
          return JSON.parse(context);
        } catch (e) {}
      }
    }
    return null;
  }
  set(context: CustomerData) {
    if (this.winRef.localStorage) {
      this.winRef.localStorage.setItem(KN_BR_CUSTOMER_CONTEXT_STORAGE_KEY, JSON.stringify(context));
    }
  }
  remove() {
    if (this.winRef.localStorage) {
      this.winRef.localStorage.removeItem(KN_BR_CUSTOMER_CONTEXT_STORAGE_KEY);
    }
  }
}
